import thumbsup from '@assets/thumbsup-emoji.png';
import renovatedIssueTracker from "../../../../content/blog/assets/renovated-issue-tracker.png";
import * as React from 'react';
export default {
  thumbsup,
  renovatedIssueTracker,
  React
};